import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import nodejs from '../assets/nodejs.png'
import react from '../assets/react.png';
import typescript from '../assets/typescript.png';
import backimg from'../assets/backimg.png';
import dsalgo from "../assets/dsalgo.jpg";
import webd from'../assets/webd.webp';

import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import mongo from '../assets/mongo.png'

import amazon from '../assets/amazon.png';
import nb from '../assets/nb.png';
import spotify from '../assets/spotify.png';
// import bck from '../assets/bck.jpg'

export default {
  email,
  mobile,
  api,
  backimg,
  mongo,
  cpp,
  css,
  git,
  html,
  javascript,
  node,
  nodejs,
  react,
  typescript,
  dsalgo,
  webd,
  circle,
  logo,
  amazon,
  nb,
  spotify,
};